// extracted by mini-css-extract-plugin
var _1 = "SignUp-module__agreeToTerms__LwOQ8";
var _2 = "SignUp-module__disabled__svLsI";
var _3 = "SignUp-module__forgot_password__ceegW";
var _4 = "SignUp-module__forgot_password_container__iogS8";
var _5 = "SignUp-module__form__FepaR";
var _6 = "SignUp-module__oauth_container__i3TrY";
var _7 = "SignUp-module__oauth_google_container__w4mam";
var _8 = "SignUp-module__or_container__fUsNR";
var _9 = "SignUp-module__sign_in_Heading__jK6TJ";
var _a = "SignUp-module__sign_up__CVvEp";
var _b = "SignUp-module__sign_up_container__gol3r";
var _c = "SignUp-module__signup_h3__tcee3";
var _d = "SignUp-module__submit_button___HCy3";
export { _1 as "agreeToTerms", _2 as "disabled", _3 as "forgot_password", _4 as "forgot_password_container", _5 as "form", _6 as "oauth_container", _7 as "oauth_google_container", _8 as "or_container", _9 as "sign_in_Heading", _a as "sign_up", _b as "sign_up_container", _c as "signup_h3", _d as "submit_button" }
